<template>
  <UserForm :typeEndPoint="'adminUsersForm'" :dataParams="{}"/>
</template>
<script>
import UserForm from '@/components/modules/admin/users/form'
export default {
  name: 'adminUsersFormCreate',
  components: {
    UserForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/admin/users/create.vue